<script lang="ts" setup>
import { cn } from '@/lib/utils'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    size?: string
  }>(),
  {
    size: 'xl',
  },
)

const sizeClass = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'text-lg rounded-sm px-0.5'
    case 'md':
      return 'text-3xl sm:text-7xl rounded-lg px-2'
    case 'xl':
      return 'text-5xl sm:text-7xl md:text-8xl lg:text-9xl rounded-xl px-3'
    default:
      return 'text-5xl md:text-8xl lg:text-9xl rounded-xl px-3'
  }
})
</script>
<template>
  <div :class="cn('text-center leading-tight lowercase bg-main  shadow-xs shadow-black/50', sizeClass)">
    <span class="text-main-foreground font-black">Clarity</span><span class="text-boss font-base">Boss</span>
  </div>
</template>
